import React, { useState } from 'react'
import './App.css';
import Card from './components/Card/Card';
import data from './data.json'
import Navbar from './components/Navbar/Navbar';
import Header from './components/Header/Header';
import {
  useNavigate,
} from "react-router-dom";

import { useSelector } from 'react-redux';

function App() {

  const [searchInput, setSearchInput] = useState('');
  const [selectedRegion, setSelectedRegion] = useState('Africa');

  const mode = useSelector(state => state.mode.value)

  const handleSearchInputChange = (event) => {
    setSearchInput(event.target.value);
  };

  const handleRegionChange = (event) => {
    setSelectedRegion(event.target.value);
  };

  const navigate = useNavigate();

  const goToNation = (i) => {
    navigate('/Nation', { state: { dati: i } });
  };

  return (
    <div className={mode ? 'dark-mode' : 'light-mode'}>
      <Header></Header>
      <Navbar
        searchInput={searchInput}
        onSearchInputChange={handleSearchInputChange}
        selectedRegion={selectedRegion}
        onRegionChange={handleRegionChange}
        classe={mode}
      />
      <div className='cards'>
        {data.map((s, index) => {
          if (searchInput !== '') {
            if (s.name.toLocaleLowerCase().startsWith(searchInput.toLocaleLowerCase())) {
              return (
                <div onClick={() => goToNation(index)}>
                  <Card class={mode} key={s.numericCode} name={s.name} flag={s.flag} population={s.population} region={s.region} capital={s.capital} />
                </div>
              )
            }else{
              return null;
            }
          } else if (selectedRegion === s.region) {
            return (
              <div onClick={() => goToNation(index)}>
                <Card class={mode} key={s.numericCode} name={s.name} flag={s.flag} population={s.population} region={s.region} capital={s.capital} />
              </div>
            )
          }else{
            return null
          }
        }
        )
        }
      </div>
    </div>
  )
}
export default App;